import { LatLngExpression } from "leaflet";
import { Polygon } from "react-leaflet";
import LazyPopup from "./LazyPopup";
import React from "react";
import { Text as BlasterText } from "@blasterjs/core";
import { UUID } from "../models";
import { AppDispatch } from "../store";
import { useAppSelector } from "../hooks";
import AnnotationTooltip from "./AnnotationTooltip";

interface Props {
  readonly positions: ReadonlyArray<ReadonlyArray<LatLngExpression>>;
  readonly date: string;
  readonly annotationId: UUID;
  readonly color: string | null;
  readonly canDelete: boolean;
  readonly isClickable: boolean;
  readonly freehandClassId: UUID | null;
  readonly source: string;
  dispatch: AppDispatch;
}

export const defaultColor = "#FFFF00";

const FreehandAnnotation = ({
  positions,
  date,
  annotationId,
  color,
  canDelete,
  isClickable,
  freehandClassId,
  source,
  dispatch
}: Props) => {
  const hpfVisibility =
    source === "CR"
      ? useAppSelector(state => state.caseImageViewer.manualHpfVisibility)
      : useAppSelector(state => state.caseImageViewer.aiHpfVisibility);

  const hidden = hpfVisibility.find(
    x =>
      (x.hpfClassid === freehandClassId && x.hpfId === null && x.pointClassId === null) ||
      (x.hpfId === annotationId && x.pointClassId === null)
  );

  if (hidden) return <></>;

  const colorWithFallback = color || defaultColor;
  return (
    <Polygon
      positions={positions as LatLngExpression[][]}
      pathOptions={{
        color: colorWithFallback,
        fillColor: colorWithFallback,
        fillOpacity: 0.1
      }}
    >
      {isClickable && (
        <LazyPopup
          closeButton={false}
          className="annotation-popup"
          renderContent={() => (
            <AnnotationTooltip
              annotationId={annotationId}
              canDelete={canDelete}
              dispatch={dispatch}
            >
              <div style={{ paddingTop: "0.2rem", paddingBottom: "0.2rem", lineHeight: "1" }}>
                <BlasterText fontSize="8pt">{date}</BlasterText>
              </div>
            </AnnotationTooltip>
          )}
        />
      )}
    </Polygon>
  );
};

export default FreehandAnnotation;
